<div class="container-fluid">
  <div class="mega_body-content">
    <div class="col-12- col-sm-12 col-md-12 col-lg-12">
      <ng-container *ngIf="hasValidationError">
        <div class="row error-banner-container">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1">
            <div class="status-icon float-end">
              <img alt="" src="assets/images/icon_error_white.svg" />
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-9 col-lg-9">
            <p class="file-format-text">
              There were errors detected with some of the submitted pool details. Review the Error
              Log below and make all necessary changes. No pools will be submitted until all errors
              have been resolved.
            </p>
          </div>
          <div class="col-1 col-sm-1 col-md-2 col-lg-2">
            <div class="exit-button float-end" (click)="closeMessageBanner()">
              <img src="assets/images/x_white.svg" />
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="mega_header-information__sub-header">Enter Pool Details</div>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
      <div class="line-break"></div>
    </div>

    <div
      class="col-12 col-sm-12"
      [ngClass]="showErrorSection ? 'col-md-8 col-lg-8' : 'col-md-12 col-lg-12'"
    >
      <p>
        Select a Pool Type, then enter or copy and paste your pool details into the form below.
        <br />
        Please note that only 50 pools can be created at a time.
      </p>
      <div class="mega-type-left">
        <label class="lable-top-10">Pool Type</label>

        <div class="dropdown p__bottom-24" (mouseleave)="closeMegaTypeDropdown()">
          <button
            class="btn btn-secondary dropdown-toggle truncate-text mega-type-dropdown"
            type="button"
            id="dropdownMenuSelectMegaType"
            (click)="toggleMegaTypeDropdown()"
            [attr.aria-expanded]="isMegaTypeDropdownOpen"
          >
            {{ selectedMegas ? selectedMegas : selectMegaTypePlaceholder }}
            <span class="fa fa-chevron-down mega-dropdown-caret"></span>
          </button>
          <ul class="dropdown-menu ul-mega-type" [ngClass]="{ show: isMegaTypeDropdownOpen }">
            <li *ngFor="let mMegaType of megaTypes; trackBy: trackByIdentity">
              <button type="button" class="dropdown-item" (click)="setSelectedMegaType(mMegaType)">
                {{ mMegaType }}
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="mega-type-right" *ngIf="showGrid">
        <button
          class="button fm-tertiary-button"
          [disabled]="countOfCopiedRow === 0 || showStartOverButton"
          (click)="clearTableData()"
          *ngIf="!showErrorSection"
        >
          CLEAR FORM
        </button>
      </div>

      <div class="table-top-110" *ngIf="showGrid">
        <ag-grid-angular
          style="width: 100%; height: 500px"
          class="ag-theme-alpine ag-mega-grid"
          [rowData]="rowData()"
          [columnDefs]="columnDefs()"
          [gridOptions]="gridOptions"
          [suppressRowClickSelection]="true"
          [enableCellTextSelection]="true"
          [ensureDomOrder]="true"
        ></ag-grid-angular>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 review-button" *ngIf="showGrid">
        <p><b>Total Pools </b>: {{ countOfCopiedRow }} of 50 max</p>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 review-button" *ngIf="showGrid">
        <button
          class="button fm-primary-button"
          [disabled]="!reviewButtonEnabled"
          (click)="validateMultiMega()"
        >
          {{ reviewButtonText }}
        </button>
        <button
          class="button fm-tertiary-button start-over"
          *ngIf="showStartOverButton"
          (click)="callStartOver()"
        >
          {{ startOverButtonText }}
        </button>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-4 col-lg-4" *ngIf="showErrorSection">
      <div class="error-section">
        <div class="error-border">
          <p class="error-header total-error">Total Errors : {{ totalErrorCount }}</p>
        </div>
        <div class="error-border" *ngFor="let errorObj of errorResult; trackBy: trackByIdentity">
          <p class="error-header">{{ errorObj.entityCategory }}</p>

          <p *ngFor="let errorMessage of errorObj.errors; trackBy: trackByIdentity">
            <b> <span class="font-error fa-circle"></span> Row {{ errorMessage.rowNumString }}</b> :
            {{ errorMessage.errorMessage }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="showWarningMsg">
    <div class="enter-mega-model-window">
      <div class="panel panel-default fadeInUpBig">
        <button
          type="button"
          class="close float-end"
          aria-label="Close"
          (click)="cancelChangeMegaType()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="panel-body mega-cancel-confirmation-model">
          <p>
            You are attempting to change your Pool Type.<br />
            By doing so, any data you have entered will be lost.
          </p>
          <br />
          <h4>Do you wish to proceed?</h4>
          <br />
          <button class="button fm-tertiary-button" (click)="cancelChangeMegaType()">CANCEL</button>
          <button class="button fm-primary-button" (click)="proceedChangeMegaType()">YES</button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
